import { useCallback } from "react";

export const useExternalLink = () => {
  const handleExternalLink = useCallback(
    (url, linkText = "", location = "unknown") => {
      // Track GTM events for Shopify and Calendly links
      if (window.dataLayer) {
        if (url.includes("myshopify.com")) {
          window.dataLayer.push({
            event: "shopify_link_click",
            link_text: linkText || "Shopify Link",
            link_url: url,
            link_location: location,
            timestamp: new Date().toISOString(),
          });
        } else if (url.includes("calendly.com")) {
          window.dataLayer.push({
            event: "calendly_link_click",
            link_text: linkText || "Calendly Link",
            link_url: url,
            link_location: location,
            timestamp: new Date().toISOString(),
          });
        }
      }

      // Add a small delay to prevent mobile Safari from blocking the popup
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";

        // For mobile Safari, we need to append to body and click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, 100);
    },
    []
  );

  return handleExternalLink;
};
